<template>
  <div>
    <div 
      v-if="!isEditing || readonly" 
      @click="startEditing" 
      class="editable-field"
      :class="{ 'editable': !readonly, 'no-label': hideLabel }"

    >
      <div v-if="!hideLabel" class="text-caption">{{ label }}</div>
      <div v-if="isCurrency">
        ${{ formatCurrency(modelValue) }}
      </div>
      <div v-else>
        {{ modelValue || '—' }}
      </div>
    </div>
    <v-text-field
      v-else
      class="editable-field"
      v-model="localValue"
      :label="hideLabel ? '' : label"
      :type="type"
      :prefix="isCurrency ? '$' : undefined"
      density="compact"
      hide-details
      :loading="loading"
      @blur="completeEdit"
      @keyup.enter="completeEdit"
      @keyup.esc="cancelEdit"
      autofocus
    ></v-text-field>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  label: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'text'
  },
  isCurrency: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  hideLabel: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'edit-complete'])

const isEditing = ref(false)
const localValue = ref('')

// Update local value when prop changes
watch(() => props.modelValue, (newValue) => {
  if (!isEditing.value) {
    localValue.value = newValue
  }
}, { immediate: true })

const startEditing = () => {
  if (!props.loading) {
    localValue.value = props.modelValue
    isEditing.value = true
  }
}

const completeEdit = () => {
  isEditing.value = false
  if (localValue.value !== props.modelValue) {
    emit('update:modelValue', localValue.value)
    emit('edit-complete')
  }
}

const cancelEdit = () => {
  localValue.value = props.modelValue
  isEditing.value = false
}

const formatCurrency = (value) => {
  return Number(value || 0).toFixed(2)
}
</script>

<style scoped>
.editable-field {
  border-radius: 4px;
  min-height: 40px;
}
.editable {
  cursor: pointer;
}
.no-label {
  border: 1px solid rgba(var(--v-theme-primary), 0.2);
  min-height: 30px !important;
}
.editable:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.text-caption {
  color: rgba(var(--v-theme-on-surface), 0.6);
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.0333333333em;
}
</style> 